import { AnnotationsService } from '@insync-students-lib/services/annotations/annotations.service';
import { AssignmentsService } from '@insync-students-lib/services/assignments/assignments.service';
/**
 * It defines the service context state and provides convenient methods to obtain services.
 * This context is used to use/provide the services to components.
 */
export class ServiceContextState {
  static newInstance(options?): ServiceContextState {
    return new ServiceContextState({
      assignmentsService: AssignmentsService.newInstance(options),
      annotationsService: AnnotationsService.newInstance(options)
    });
  }
  assignmentsService: AssignmentsService;
  annotationsService: AnnotationsService;
  constructor(state: Partial<ServiceContextState> = {}) {
    Object.assign(this, state);
  }
}